import React from "react";
import { getImageUrl } from "../../utils/generalLiveCenter";
import NextImage from "../common/NextImage";

const BasketballTeamScoreBox = ({ data, sport = "basketball" }) => {
  if (!data || data.length < 2) return null;

  return (
    <div className="lineupbox">
      <div className="global_table team_lineup">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Team</th>
              <th></th>
              <th>W - L</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong className="count_num">{data[0]?.pts}</strong>
              </td>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl("", "", sport, data[0]?.team_id)}
                      width={26}
                      height={26}
                      alt="player"
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">{data[0]?.team?.nm}</strong>
                  </div>
                </div>
              </td>
              <td>
                <ul className="prev_match_status">
                  {(data[0]?.lfm || []).map((w, i) => (
                    <li key={w + i} className={`${w === "W" ? "win" : "loss"}`}>
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                {data[0]?.wo} - {data[0]?.lo}
              </td>
            </tr>
            <tr>
              <td>
                <strong className="count_num">{data[1]?.pts}</strong>
              </td>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl("", "", sport, data[1]?.team_id)}
                      width={26}
                      height={26}
                      alt="player"
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">{data[1]?.team?.nm}</strong>
                  </div>
                </div>
              </td>
              <td>
                <ul className="prev_match_status">
                  {(data[1]?.lfm || []).map((w, i) => (
                    <li key={w + i} className={`${w === "W" ? "win" : "loss"}`}>
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                {data[1]?.wo} - {data[1]?.lo}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasketballTeamScoreBox;
